import { NavItem } from "../../../components/nav/item";
import { NavSubItem } from "../../../components/nav/sub-item";
import { CRM } from "icons";

export function CrmNavigations() {
  return (
    <NavItem
      title="CRM"
      icon={CRM}
      url="/crm"
      matchExact={true}
      requiredPermissions={{
        collection: "clients",
        type: "collection",
      }}
    >
      <NavSubItem
        title="Clients"
        url="/crm/clients"
        requiredPermissions={{
          collection: "clients",
          type: "collection",
        }}
      />
      <NavSubItem
        title="Companies"
        url="/crm/companies"
        requiredPermissions={{
          collection: "companies",
          type: "collection",
        }}
      />
    </NavItem>
  );
}
